import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AddCoupon from "../../../components/SuperAdmin/Coupon/AddCoupon";

export default withRouter(connect()(AddCoupon));
